<template>
    <div>
        <div class="compass">
            <Intro v-if="currentView === 'intro'" v-on:changeViewTo="changeViewTo"/>
            <Questions v-if="currentView === 'questions'" :questions="questions" v-on:changeViewTo="changeViewTo" v-on:addToScore="addToScore" v-on:addToUserAnswers="addToUserAnswers" />
            <Result v-if="currentView === 'result'" :score="score" :maxscore="maxScore" :feedback="feedback"  />
        </div>
    </div>
</template>

<script>
import Intro from './Intro.vue'
import Questions from './Questions.vue'
import Result from './Result.vue'
export default {
    name: 'Compass',
     components: {
        Intro,
        Questions,
        Result
    },
    created () {

      var images = [
        this.$root.$data.imagePrefix +'intro.gif',
        this.$root.$data.imagePrefix +'intro-compass.gif',
        this.$root.$data.imagePrefix +'courage.gif',
        this.$root.$data.imagePrefix +'credibility.gif',
        this.$root.$data.imagePrefix +'passion.gif',
        this.$root.$data.imagePrefix +'diversity.gif',
        this.$root.$data.imagePrefix +'easiness.gif',
        this.$root.$data.imagePrefix +'needle.png',
        this.$root.$data.imagePrefix +'compass.png',
      ]
      images.forEach(element => {
        let img = new Image();
        img.src = element;
      });
    
    },
    methods: {
        changeViewTo: function(newView) {
           this.currentView = newView;
           this.goToTop();
        },
        addToUserAnswers: function(value) {
            this.userAnswers.push(value);
        },
        addToScore: function(value) {
            this.score += value;
        },
        goToTop: function() {
            window.scrollTo(document.querySelector('#corporate-values').offsetTop, 0);
        }
    },

    data: function() {
        return {
            score: 0,
            maxScore: 500,
            currentView: 'intro',
            userAnswers: [],
            questions: [
                {
                    id: 1,
                    question: 'Sie übernehmen ein Innovations-Projekt, in dem Sie gemeinsam mit Imkern unserer Region eine digitale Waage zur Ermittlung der Aktivität des Bienenstamms bauen. Kurz vor Finalisierung des Prototypen erhalten Sie die Nachricht, dass die Förderung dieses Projekts ausläuft und Sie werden von Ihrer Führungskraft angehalten, Ihre Kapazitäten auf andere Projekte zu konzentrieren. Was tun Sie?',
                    answers: [
                        {
                            id: 1,
                            answer: 'Ich beende das Projekt sofort.',
                            points: 0
                        },
                        {
                            id: 2,
                            answer: 'Ich beende das Projekt und stelle den Imkern meinen aktuellen Projektstand zur Verfügung.',
                            points: 50
                        },
                        {
                            id: 3,
                            answer: 'Ich mache in meiner Freizeit weiter, weil ich das Thema so wichtig finde.',
                            points: 50
                        },
                        {
                            id: 4,
                            answer: 'Wir suchen in unseren internen Netzwerken Mitstreiter, denen das Thema ebenso am Herzen liegt und versuchen damit, andere anzustecken. ',
                            points: 100
                        }
                    ],
                    topic: 'Leidenschaft',
                    image: 'passion',
                    description: 'Wir brennen für unsere Themen und treiben sie voran. Wir glauben daran, was wir heute tun, zahlt sich morgen aus. Hierbei sind wir mit ganzem Herzen dabei und geben täglich unser Bestes. Damit begeistern wir andere und stecken sie an. Unsere Überzeugung: Nur gemeinsam können wir erfolgreich sein.'
                },
                {
                    id: 2,
                    question: 'Sie haben die Aufgabe, ein Team für ein Projekt zusammen zu stellen, in dem es darum geht, übergreifend in der Unternehmensgruppe neue Lösungen zu erarbeiten. Wie gehen Sie vor?',
                    answers: [
                        {
                            id: 1,
                            answer: 'Ich suche mir Kollegen/innen, von denen ich weiß, dass sie ähnlich denken, wie ich, damit wir schnell zum Ziel kommen.',
                            points: 50
                        },
                        {
                            id: 2,
                            answer: 'Ich frage in meinem direkten Kollegenkreis, wer gerade Zeit hat, damit das Projekt schnell abgearbeitet wird.',
                            points: 0
                        },
                        {
                            id: 3,
                            answer: 'Ich frage meine Führungskraft, wen sie mir empfiehlt, auf ihre Meinung kann ich mich verlassen.',
                            points: 50
                        },
                        {
                            id: 4,
                            answer: 'Ich frage gezielt sowohl erfahrene als auch neue Kollegen/innen aus unterschiedlichen Bereichen, um möglichst viele unterschiedliche Perspektiven zu bekommen.',
                            points: 100
                        }
                    ],
                    topic: 'Vielfalt',
                    image: 'diversity',
                    description: 'Vielfalt bereichert unsere Welt und unser Miteinander. Wir wollen deshalb ein Arbeitsumfeld schaffen, in dem sich jeder unserer Mitarbeitenden willkommen, respektiert, unterstützt und wertgeschätzt fühlt. Vielfalt bedeutet für uns aber noch mehr: In unserer Unternehmensgruppe treiben wir auch eine Vielfalt an Themen und setzen auf neue Möglichkeiten. Dabei schätzen wir unterschiedliche Denk- und Vorgehensweisen. Denn wir wissen: Gemeinsamkeiten bringen uns zusammen, Vielfalt bringt uns weiter.'
                },
                {
                    id: 3,
                    question: '	Ihr 40. Geburtstag steht an, den Sie gern mit Ihren Freunden bei sich zuhause feiern möchten. Allerdings wissen Sie, dass von den 30 Gästen, die Sie einladen möchten, fünf Vegetarier und zwei schwanger sind. sechs essen kein Schweinefleisch, mal von den Lebensmittelunverträglichkeiten abgesehen. Was tun Sie?',
                    answers: [
                        {
                            id: 1,
                            answer: 'Ich suche mir ein Menü aus, das mir schmeckt, es findet schon jeder etwas.',
                            points: 50
                        },
                        {
                            id: 2,
                            answer: 'Ich kläre den Caterer über alle mir bekannten Besonderheiten meiner Gäste auf und lasse ihn ein Menü zusammenstellen.',
                            points: 50
                        },
                        {
                            id: 3,
                            answer: 'Wir machen einfach eine Mitbring-Party',
                            points: 100
                        },
                        {
                            id: 4,
                            answer: 'Ich geb´s auf!',
                            points: 0
                        }
                    ],
                    topic: 'Einfachheit',
                    image: 'easiness',
                    description: 'Unser Alltag wird immer komplizierter. Eine übergroße Auswahl an Möglichkeiten macht unsere Entscheidungen schwer – sowohl im privaten als auch im beruflichen Kontext. Wir setzen in unserer Unternehmensgruppe auf Einfachheit. Darunter verstehen wir eine bestimmte Art zu denken: Wir machen die Dinge für unsere Kunden aber auch unsere Kollegen einfach – denn wir machen’s einfach.'
                },
                {
                    id: 4,
                    question: 'Sie stellen mit Erschrecken fest, dass Sie einen wichtigen Präsentationstermin vor dem Vorstand falsch in Ihren Kalender eingetragen haben und dieser in einer Stunde stattfindet. Die Präsentation lässt sich innerhalb einer Stunde fertigstellen, allerdings tragen Sie heute ihr Hard-Rock-Café T-Shirt. Was tun Sie?',
                    answers: [
                        {
                            id: 1,
                            answer: 'Sie fahren schnell (15 Minuten) nach Hause, ziehen sich um und improvisieren bei der Präsentation.',
                            points: 50
                        },
                        {
                            id: 2,
                            answer: 'Sie nutzen die Zeit, die Präsentation zu erstellen und präsentieren im T-Shirt. Wer sagt denn, dass man beim Vorstand nur im Hemd/Bluse erscheinen darf.',
                            points: 100
                        },
                        {
                            id: 3,
                            answer: 'Sie fragen Ihren Kollegen, ob er die Präsentation für Sie hält.',
                            points: 50
                        },
                        {
                            id: 4,
                            answer: 'Sie verschieben den Termin.',
                            points: 0
                        }
                    ],
                    topic: 'Mut',
                    image: 'courage',
                    description: 'Es erfordert Mut, Hindernisse, Denkmuster und Erwartungshaltungen zu hinterfragen und dadurch etwas Neues zu schaffen. Wir fördern und ermutigen unsere Mitarbeitenden, ihre Komfortzone zu verlassen, sich zu trauen, ihre Meinung zu vertreten, Neues zu wagen und aus Fehlern zu lernen.'
                },
                {
                    id: 5,
                    question: 'Einer Ihrer wichtigsten Geschäftspartner ist in finanziellen Schwierigkeiten und plant deshalb, die Produktion ins Ausland zu verlagern. Die Infrastruktur vor Ort ist schlecht ausgebaut, sodass Schadstoffe bei der Produktion in das Grundwasser abgegeben werden. Was tun Sie?',
                    answers: [
                        {
                            id: 1,
                            answer: 'Ich kündige sofort die Partnerschaft, weil das nicht zu unseren Werten passt.',
                            points: 50
                        },
                        {
                            id: 2,
                            answer: 'Wenn er mir zeigt, dass er sich ansonsten nachhaltig engagiert, kann ich es akzeptieren.',
                            points: 50
                        },
                        {
                            id: 3,
                            answer: 'Ich spreche es nicht an, da es nicht meine Aufgabe ist und die Geschäftsbeziehung bislang sehr gut war.',
                            points: 0
                        },
                        {
                            id: 4,
                            answer: 'Ich bereite ein Gespräch mit dem Partner vor, um ihm unseren Wertekonflikt mitzuteilen und ihn zu bitten nach einer geeigneten Lösung zu suchen.',
                            points: 100
                        }
                    ],
                    topic: 'Glaubwürdigkeit',
                    image: 'credibility',
                    description: 'Wir sind ein Unternehmen, das sich treu bleibt und seit vielen Jahren in der Region eng verwurzelt ist. Unser Anspruch: Bei uns stimmen Worte und Taten überein. Wir kommunizieren daher offen und sind authentisch. Auf uns können sich unsere Kunden, unsere Partner aber auch unsere Kolleginnen und Kollegen immer verlassen.'
                }
            ],
            feedback: [
                {
                    neededScoreInPercent: 0,
                    title: 'Wir passen noch nicht so recht zueinander',
                    description: 'Aber das muss ja nicht so bleiben. Wenn Sie möchten: Lernen Sie uns besser kennen und sehen Sie, ob Sie sich wohlfühlen und unsere Denkansätze teilen. Erfahren Sie mehr über <a href="https://www.badenova.de/ueber-uns/wir-sind/unsere-werte/" target="_blank">unsere Werte</a>.'
                },
                {
                    neededScoreInPercent: 50,
                    title: 'Wir sind uns ähnlich, aber nicht in allem stimmig',
                    description: 'Unsere Werte decken sich nur zum Teil, manchmal braucht es aber auch unterschiedliche Perspektiven. Wir freuen uns hierzu mit Ihnen in den Austausch zu gehen. Lernen Sie uns noch besser kennen und erfahren Sie mehr über <a href="https://www.badenova.de/ueber-uns/wir-sind/unsere-werte/" target="_blank">unsere Werte</a>.'
                },
                {
                    neededScoreInPercent: 75,
                    title: 'Wir passen gut zusammen!',
                    description: 'Unsere Wertvorstellungen decken sich! Gemeinsam können wir viel erreichen, um uns beidseitig weiterzuentwickeln. Kommen Sie an Bord und gestalten Sie die Zukunft mit uns. Lernen Sie uns noch besser kennen und erfahren Sie mehr über <a href="https://www.badenova.de/ueber-uns/wir-sind/unsere-werte/" target="_blank">unsere Werte</a>.'
                }
            ]
        }
        
    }
   
}
</script>
<style lang="scss">
html {
  scroll-behavior: smooth;
}

p {
    text-align: center;
    margin: 0;
}
.compass {
    scroll-behavior: smooth;
    text-align: center;
    margin: 15px 0;
    @media (min-width: 768px) {
        margin: 25px 0;
    } 
}
.button--fixed {
    
    margin-top: 15px;
     @media (min-width: 768px) {
         margin-top: 53px;
     }
 
}
</style>